
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import store from '@/store';
import { Prop, Watch } from 'vue-property-decorator';

@Options({})
export default class descriptionBinder extends Vue {

    @Prop() htmlText: string;

    // @Watch('htmlText')
    // onHtmlChange(){
    //     setTimeout(() => {
    //         let container = this.$refs.htmlContainer as HTMLDivElement;
    //         let as = container.querySelectorAll('a[href]');
    //         as.forEach(x => {
    //             x.addEventListener('click', (ev) => {
    //                 store.state.openBrowser(ev);
    //             });
    //         })

    //     }, 100)
    // }

    onContainerClick(e: MouseEvent){
        const target = e.target as HTMLElement | null;
        // Cerca l'anchor più vicino che abbia href
        const anchor = target?.closest?.('a[href]') as HTMLAnchorElement | null;
        if (!anchor)
            return;

        // Passo l'evento alla tua funzione: farà preventDefault da sola
        store.state.openBrowser(e);
    }


}
